import { json_headers, request } from './common';

const basePath = () => `${window.configs.API_HOST}/api/connections/synxis`;

export const detectMissingRates = (propertyId: string): Promise<{ status: number; message: string }> => {
  return request(`${basePath()}/detect-missing-rates/${propertyId}`, {
    method: 'POST',
    headers: json_headers,
  });
};

export type StaleCatalogueChain = {
  chainId: string;
  chainName: string;
  lastDumpAt: string;
  daysSinceDump: number;
  daysUntilStale: number;
  cadence: string;
  message: string;
};

export const getCatalogueStaleness = (): Promise<{
  status: number;
  result: { stale: Array<StaleCatalogueChain> };
}> => {
  return request(`${basePath()}/catalogue-staleness`, {
    method: 'GET',
    headers: json_headers,
  });
};
